import { createContext, RefObject, useContext } from 'react';

export type ScrollContainerRef = RefObject<HTMLElement> | null;

export const ScrollContainerContext =
  createContext<ScrollContainerRef>(null);

export const useScrollContainer = (): ScrollContainerRef =>
  useContext(ScrollContainerContext);

